import React from "react";
import { products } from "../data/products";
import ProductCard from "../components/ProductCard";

function Drop() {
  const groupedProducts = products.reduce((acc, product) => {
    if (!acc[product.drop]) {
      acc[product.drop] = [];
    }
    acc[product.drop].push(product);
    return acc;
  }, {});

  return (
    <div className="p-8">
      {Object.keys(groupedProducts).map((drop) => (
        <div key={drop} className="mb-8">
          <h1 className="text-white text-4xl font-bold mb-6">Drop {drop}</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {groupedProducts[drop].map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Drop;
